import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import Loader from './elements/Loader'
import Sidebar from './Sidebar'
import Toolbar from './Toolbar'
import Products from './Products'
import Pagination from './Pagination'
import ArticlesBlogs from './ArticlesBlogs'
import NoResults from './NoResults'

export default () => {
    const { response: { products }, loading } = useAppState();
    const [ sidebarActive, setSidebarActive ] = useState(false);
    const [ sortByActive, setSortByActive ] = useState(false);
    const [ resultsView, setResultsView ] = useState('products');
    const foundProducts = products && products.total > 0;

    useEffect(() => {
        sidebarActive || (sortByActive && window.innerWidth < 1000)
            ? document.querySelector('html').classList.add('lock-all')
            : document.querySelector('html').classList.remove('lock-all')
    }, [sidebarActive, sortByActive])

    const toggleSidebar = () => {
        setSidebarActive(prevSidebarActive => !sidebarActive);
    }

    const toggleSortBy = () => {
        setSortByActive(prevSortByActive => !prevSortByActive)
    }

    const changeResultsView = (type) => {
        if(type === resultsView) return;
        setResultsView(type);
    }

    return (
        <div class="ns-serp" data-nosto-element="search" style={loading ? 'position: relative;' : ''}>
            {loading && !foundProducts ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Sidebar
                        toggleSidebar={toggleSidebar}
                        sidebarActive={sidebarActive}
                        resultsView={resultsView}
                    />
                    <div class="ns-serp-body product-facet__main anchor">
                        <Toolbar
                            toggleSidebar={toggleSidebar}
                            sortByActive={sortByActive}
                            toggleSortBy={toggleSortBy}
                            changeResultsView={changeResultsView}
                            resultsView={resultsView}
                        />
                        <div 
                            id="ns-products-view" 
                            hidden={resultsView !== 'products'} 
                            role="region" 
                            aria-live="polite"
                        >
                            <Products />
                            <Pagination />
                        </div>
                        <ArticlesBlogs 
                            resultsView={resultsView}
                        />
                    </div>
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
